import { ReactNode } from "react";
import { renderToString } from "react-dom/server";

interface ZephrFeatureProps {
  name: string;
  children?: ReactNode;
}

export const ZephrFeature = ({ name, children }: ZephrFeatureProps) => {
  return (
    <div
      dangerouslySetInnerHTML={{
        __html: `<div class="zephr-feature ${name}">${renderToString(children)}</div>`,
      }}
      suppressHydrationWarning
    />
  );
};
